export const CTRL = 'ctrlKey';
export const META = 'metaKey';
export const ALT = 'altKey';
export const SHIFT = 'shiftKey';
